import { render } from "./EditTeacher.vue?vue&type=template&id=06f70f06"
import script from "./EditTeacher.vue?vue&type=script&lang=js"
export * from "./EditTeacher.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__